import React, { useEffect, useRef } from 'react';

const AnimatedHero = () => {
  const heroRef = useRef(null);
  const mousePosition = useRef({ x: 0, y: 0 });
  const currentRotation = useRef({ x: 0, y: 0 });
  const animationFrameId = useRef(null);

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    let lastTime = Date.now();

    // Throttled mouse move handler
    const handleMouseMove = (e) => {
      mousePosition.current = {
        x: e.clientX,
        y: e.clientY
      };
    };

    // Animation loop
    const animate = () => {
      const now = Date.now();
      const elapsed = now - lastTime;

      // Floating animation
      const floatY = Math.sin(now * 0.0015) * 15;

      // Calculate target rotation based on mouse position
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const mouseX = (mousePosition.current.x - windowWidth / 2) / (windowWidth / 2);
      const mouseY = (mousePosition.current.y - windowHeight / 2) / (windowHeight / 2);

      const targetRotateX = mouseY * -15;
      const targetRotateY = mouseX * 15;

      // Smooth interpolation (lerp) for rotation
      const lerpFactor = Math.min(elapsed * 0.005, 1); // Smoother interpolation
      currentRotation.current.x += (targetRotateX - currentRotation.current.x) * lerpFactor;
      currentRotation.current.y += (targetRotateY - currentRotation.current.y) * lerpFactor;

      // Apply transform directly to element
      hero.style.transform = `perspective(1000px) translateY(${floatY}px) rotateX(${currentRotation.current.x}deg) rotateY(${currentRotation.current.y}deg) rotateZ(-5deg)`;

      lastTime = now;
      animationFrameId.current = requestAnimationFrame(animate);
    };

    // Start animation
    animationFrameId.current = requestAnimationFrame(animate);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div
      ref={heroRef}
      className="w-auto h-full flex items-center justify-center"
      style={{
        willChange: 'transform',
        transformStyle: 'preserve-3d'
      }}
    >
      <img
        src={`/binagotchi_hero2_1.png`}
        alt='hero'
        className="w-auto h-full object-contain drop-shadow-2xl"
        style={{ transformStyle: 'preserve-3d' }}
      />
    </div>
  );
};

export default AnimatedHero;